import { flowRight as compose } from 'lodash';

import withUser from '~lib/common/hoc/withUser';

import dataView from '~lib/common/hoc/dataView';
import renameProps from '~lib/common/hoc/renameProps';
import queries from '~lib/common/queries/CaseConfiguration';

import CaseBuildAssistant from '../components/CaseBuildAssistant.vue';

const enhance = compose(
  dataView({
    queries: {
      add: queries.add,
      save: queries.save,
      fetchById: queries.fetchById,
    },
  }),
  renameProps({ itemData: 'caseConf' }),
  withUser(),
);

export default enhance(CaseBuildAssistant);
